import { Flex, Text } from '@chakra-ui/react'
import {
  baseBasicMidwifeInfo,
  basePracticeSelectField,
  baseRenderingProviderField,
  baseRenderingProvidersField,
  colors,
  FieldMap,
  IdField,
  ListField,
  makeFieldOptional,
  moreMidwifeInfo,
  PracticeWithAdmin,
  replaceField,
  WithId,
} from '@hb/shared'

export const PracticeSelectPreview = ({ practice }: { practice: WithId<PracticeWithAdmin> }) => {
  const { name, fname, lname } = practice
  return (
    <Flex px={2} py={1} w="100%" flexFlow="column">
      <Text fontWeight={500} color="gray.600">
        {name}
      </Text>
      {/* <Flex gap={2} align="center"> */}
      <Text lineHeight={1} color="gray.600" fontSize="md">
        {fname} {lname}
      </Text>
      {/* </Flex> */}
    </Flex>
  )
}

export const practiceSelectField: IdField<PracticeWithAdmin> = {
  ...basePracticeSelectField,
  renderOption: practice => <PracticeSelectPreview practice={practice} />,
}

export const optionalPracticeSelectField = makeFieldOptional(practiceSelectField)

export const gynPracticeSelectField: IdField<PracticeWithAdmin> = {
  ...optionalPracticeSelectField,
  placeholder: 'Which practice are you working with?',
}

export const renderingProviderToName: FieldMap['toName'] = v => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {v?.fname || 'NO FIRST NAME'} {v?.lname || 'NO LAST NAME'}
    <span
      style={{
        background: v?.inactive ? colors.orange.hex : colors.green.hex,
        fontSize: '0.8rem',
        marginLeft: '0.5rem',
        color: 'white',
        borderRadius: '4px',
        padding: '0.3rem',
        paddingBottom: '0.2rem',
      }}>
      {v?.inactive ? 'INACTIVE' : 'ACTIVE'}
    </span>
  </div>
)

export const renderingProviderField: FieldMap = {
  ...baseRenderingProviderField,
  toName: renderingProviderToName,
}

export const renderingProvidersField: ListField = {
  ...baseRenderingProvidersField,
  itemFields: renderingProviderField,
}

// export const basicMidwifeInfo: FieldMap = {
//   name: 'Midwife',
//   children: {
//     isGroup: practiceIsGroupField,
//     group: practiceGroupField,
//     name: midwiferyNameField,
//     specialty: specialtyField,
//     fname: practiceFnameField,
//     lname: practiceLnameField,
//     taxId: practiceTaxIdField,
//     ssn: practiceSsnField,
//     renderingProviders: renderingProvidersField,
//     zipCode: practiceZipCodeField,
//     npi: practiceNpiField,
//     email: alternateEmailField,
//     phone: providerPhoneField,
//     otherPhones: providerOtherPhonesField,
//     acceptedPaymentMethods: acceptedPaymentMethodsField,
//     redFlaggedReason: practiceRedFlaggedReasonField,
//   },
// }

export const basicMidwifeInfo = replaceField(
  baseBasicMidwifeInfo,
  'renderingProviders',
  renderingProvidersField,
)

//used for collection
export const midwifeFields: FieldMap = {
  name: 'Midwife',
  children: {
    ...basicMidwifeInfo.children,
    ...moreMidwifeInfo.children,
  },
}
